<template>
    <v-autocomplete outlined :label="label" :items="items" :loading="loading" item-text="full_name" item-value="id"
                    :value="value" @input="syncInput" :search-input.sync="search" cache-items
                    no-data-text="Ingen data funnet." :hide-details="hideDetails"/>
</template>

<script>
    export default {
        props: {
            value: Number,
            label: String,
            hideDetails: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                loading: false,
                items: [],
                search: ''
            }
        },

        created() {
            if (this.value) {
                this.doSearch('' + this.value)
            }
        },

        methods: {
            syncInput(value) {
                this.$emit('input', value);
            },
            doSearch(val) {
                if (!val || val.length <= 2) {
                    return;
                }
                this.$http.get('projects/search/', {params: {search: val}}).then(response => {
                    this.items = response.data.map(it => {
                        return {
                            id: it.id,
                            full_name: `${it.id} ${it.name}`
                        }
                    });
                })
            }
        },

        watch: {
            search(val) {
                this.doSearch(val);
            },
        }
    }
</script>